var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5327 48.9987C31.0289 48.991 37.2541 46.4023 41.8441 41.805C46.4313 37.2052 49.0072 30.9721 49 24.4764C48.9949 17.9829 46.4087 11.7554 41.814 7.1629C37.2166 2.57325 30.986 -0.00261483 24.4902 1.99187e-06C17.9939 0.00255797 11.7662 2.58614 7.17355 7.1786C2.57868 11.7733 0 18.0037 0 24.5C0.0127776 30.9986 2.60158 37.2289 7.20169 41.8214C11.7991 46.4161 18.035 48.9974 24.5334 49L24.5327 48.9987ZM10.219 15.2358L15.2688 10.4136L24.5326 19.6647L33.7964 10.4136L38.8155 15.2358L29.3679 24.4993L38.8135 33.7629L33.7944 38.7819L24.5332 29.5183L15.2694 38.7793L10.2196 33.7603L19.5142 24.4993L10.219 15.2358Z",
    fill: "#D02222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalIcon);
export default __webpack_public_path__ + "static/media/delete-modal-icon.ad2465d39c69d58d2dd429aa95714623.svg";
export { ForwardRef as ReactComponent };